import logo from '@/assets/images/logo.png';

import { Separator } from '@/components/ui/separator';
import TrialSignUpForm from '@/components/trial/TrialSignUpForm';
import TrialStepper from '@/components/trial/TrialStepper';

export default function TrialSignUp() {
  const features = [
    'Autopilot that qualifies & books calls for you',
    'Social CRM for DMs - IG + FB & LinkedIn',
    'Pipeline & Analytics to measure revenue performance',
    'AI Sales Coach to guide your team',
    'Unlimited AI messages & unlimited team seats',
    'No contracts. Cancel any time.',
  ];

  return (
    <>
      <div className='flex h-screen'>
        {/* Left side - 40% */}
        <div className='relative flex w-2/5 items-center justify-center bg-background px-8'>
          <div className='mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[400px]'>
            <div className='flex h-16 shrink-0 items-center justify-center'>
              <a
                href='https://getrevio.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img className='h-20 w-auto' src={logo} alt='Revio' />
              </a>
            </div>
            <div className='flex flex-col space-y-2'>
              <h1 className='text-3xl font-semibold tracking-tight'>
                Create Your Revio Account
              </h1>
            </div>
            <div className='flex flex-col space-y-1'>
              <p className='text-sm text-muted-foreground'>
                Start turning followers into revenue in minutes.
              </p>
            </div>
            <TrialSignUpForm />
          </div>
        </div>
        <Separator orientation='vertical' />
        {/* Right side - 60% */}
        <div className='flex w-3/5 items-center justify-center bg-background p-8'>
          <div className='mx-auto w-full max-w-lg space-y-8'>
            <TrialStepper currentStep={1} title='Sign Up' />
            <div className='space-y-6'>
              <h2 className='text-2xl font-semibold'>
                What you get inside Revio
              </h2>
              <ul className='space-y-4'>
                {features.map((feature, index) => (
                  <li key={index} className='flex items-start space-x-3'>
                    <div className='mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-primary' />
                    <p className='text-sm text-muted-foreground'>{feature}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
